module.exports = __webpack_public_path__ + "img/img_zhinan@2x.c3c3df50.png";